var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headline"},[_c('img',{attrs:{"src":"/assets/images/pages/rodo/rodo-headline.png"}}),_vm._v(" "),_c('div',{staticClass:"headline__number"},[_c('b',[_vm._v(_vm._s(_vm.number))])]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.value)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ef4cda7","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/Headline.vue
// module id = 789
// module chunks = 1